import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {AccountService, AlertService} from "../services";
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';

import { Router, ActivatedRoute } from '@angular/router';
import {finalize, first} from 'rxjs/operators';
import {MatDialog} from "@angular/material/dialog";
import {ComponentTitleService} from "../services/componentTitle.service";
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";

import { locale as polish } from './i18n/pl';
import {SupplierService} from "../services/supplier.service";
import {SupplierOrderService} from "../services/supplierOrder.service";
import {Product} from "../models/product";
import {ProductService} from "../services/product.service";
import {UnitService} from "../services/unit.services";
import {VatRateService} from "../services/vatRate.service";
import {Unit} from "../models/unit";
import {VatRate} from "../models/vatRate";
import {Supplier} from "../models/supplier";
import {fuseAnimations} from "../../../@fuse/animations";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Service} from "../models/service";
import {VoucherTemplateService} from "../services/voucherTemplate.service";
import {ServiceService} from "../services/service.service";
import {VoucherTemplateGroupService} from "../services/voucherTemplateGroup.service";
import {VoucherTemplateGroup} from "../models/voucherTemplateGroup";
import {VoucherTemplateGroupList} from "../models/voucherTemplateGroupList";
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {GalleryService} from "../cms/gallery/service/gallery.service";
import {Gallery} from "../cms/gallery/model/gallery";
import {Subscription} from "rxjs";
import {HttpEventType} from "@angular/common/http";
import {GalleryItem} from "../cms/gallery/model/galleryItem";
import {UpdateGalleryItemDialogComponent} from "../cms/gallery/dialog/updateGalleryItemDialog.component";
import {DeleteGalleryItemDialogComponent} from "../cms/gallery/dialog/deleteGalleryItemDialog.component";
import {VoucherTemplate} from "../models/voucherTemplate";
import {Services} from "../models/services";
import {FirstTimeConfirmationDialogComponent} from "./dialog/firstTimeConfirmation.component";
import {SecondTimeConfirmationDialogComponent} from "./dialog/secondTimeConfirmation.component";


export const MY_FORMATS = {
    parse: {
        dateInput: 'DD-MM-YYYY',
    },
    display: {
        dateInput: 'DD-MM-YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@Component({
    templateUrl: './voucherTemplateForm.component.html',
    styleUrls: ['./voucherTemplateForm.component.scss'],
    animations   : fuseAnimations,
    providers: [
        // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
        // application's root module. We provide it at the component level here, due to limitations of
        // our example generation script.
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },

        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    ],
})

export class VoucherTemplateFormComponent implements OnInit {

    form: FormGroup;
    loading = false;
    submitted = false;
    id: string;
    isAddMode: boolean;
    isEcommerceSale: boolean = false;
    isMobileAppSale: boolean = false;
    suppliers: Supplier[];
    dialogRef: any;
    availableProducts: Product[];
    availableServices: Service[];
    units: Unit[];
    vatRates: VatRate[];
    groups: VoucherTemplateGroup[];
    gallery: Gallery;
    loadingIndicator: boolean;
    @ViewChild("fileDropRef", { static: false }) fileDropEl: ElementRef;
    files: any[] = [];
    uploadSub: Subscription;
    items: string[] = [];
    firstTimeConfirmationDialogRef: any;
    secondTimeConfirmationDialogRef: any;
    voucherTemplate: VoucherTemplate;
    saving = false;

    constructor(
        public _matDialog: MatDialog,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private alertService: AlertService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private supplierService: SupplierService,
        private supplierOrderService: SupplierOrderService,
        private productService: ProductService,
        private unitService: UnitService,
        private vatRateService: VatRateService,
        private _matSnackBar: MatSnackBar,
        private voucherTemplateService: VoucherTemplateService,
        private serviceService: ServiceService,
        private voucherTemplateGroupService: VoucherTemplateGroupService,
        private galleryService: GalleryService,
        private accountService: AccountService,
    ) {
        this.translationLoader.loadTranslations(polish);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Voucher templates');
    }

    ngOnInit() {
        this.vatRateService.getAll().subscribe((res: VatRate[]) => {
            this.vatRates = res;
        }, error => {
            this.alertService.error(error);
        });

        this.productService.getAll().subscribe((res: Product[]) => {
            this.availableProducts = res;
        }, error => {

        });

        this.serviceService.getAll().subscribe((res: Services) => {
            this.availableServices = res.items;
        }, error => {

        });

        this.voucherTemplateGroupService.getAll(0, 200).subscribe((res:VoucherTemplateGroupList) => {
            this.groups = res.items;
        }, error => {

        });

        this.id = this.route.snapshot.params['id'];
        this.isAddMode = !this.id;

        if (this.isAddMode) {
            this.componentTitleService.addPart('New');
        } else {
            this.componentTitleService.addPart('Edit');

            this.galleryService.getByObject(this.id, 'VoucherTemplate').subscribe((gallery: Gallery) => {
                this.gallery = gallery;

                for (let i=0; i<this.gallery.items.length; i++) {
                    this.galleryService.getImageById(this.gallery.id, this.gallery.items[i].id).pipe(first())
                        .subscribe((item:string) => {
                            this.gallery.items[i].image = item;
                        });
                }
            }, error => {

            });
        }

        this.form = this.formBuilder.group({
            name: ['', Validators.required],
            nameForReceipt: ['', Validators.required],
            price: [''],
            salePrice: [''],
            credits: [0],
            salePriceNet: [''],
            validityTime: [''],
            expirationDate: [''],
            vatRate: [''],
            services: this.formBuilder.array([]),
            products: this.formBuilder.array([]),
            ecommerceSalePrice: [''],
            ecommerceSalePriceNet: [''],
            nameForEcommerce: [''],
            descriptionForEcommerce: [''],
            allowEcommerceSale: [''],
            slug: [''],
            group: [''],
            quantityAvailableForEcommerce: [''],
            availableFromDate: [''],
            availableToDate: [''],
            mobileAppSalePrice: [''],
            mobileAppSalePriceNet: [''],
            nameForMobileApp: [''],
            descriptionForMobileApp: [''],
            allowMobileAppSale: [false],
            forOpenDay: [false],
            multiSport: [false],
            medicover: [false],
            pzuSport: [false],
            profit: [false],
            validFromHour: [''],
            validToHour: [''],
            activeInMonday: [true],
            activeInTuesday: [true],
            activeInWednesday: [true],
            activeInThursday: [true],
            activeInFriday: [true],
            activeInSaturday: [true],
            activeInSunday: [true],
            allowedVisitsForOpenDay: [''],
            recommended: [false],
            theLatest: [false],
            saleCommission: [0],
        });

        if (!this.isAddMode) {
            this.voucherTemplateService.getById(this.id)
                .pipe(first())
                .subscribe((x: VoucherTemplate) => {
                    this.voucherTemplate = x;

                    this.allowEcommerceSale(x.allowEcommerceSale);

                    this.f.name.setValue(x.name);
                    this.f.nameForReceipt.setValue(x.nameForReceipt);
                    this.f.price.setValue(x.price);
                    this.f.credits.setValue(x.credits);
                    this.f.salePrice.setValue(x.salePrice);
                    this.f.salePriceNet.setValue(x.salePriceNet);
                    this.f.validityTime.setValue(x.validityTime);
                    this.f.expirationDate.setValue(x.expirationDate);
                    this.f.vatRate.setValue(x.vatRate?x.vatRate.id:'');
                    this.f.ecommerceSalePrice.setValue(x.ecommerceSalePrice);
                    this.f.ecommerceSalePriceNet.setValue(x.ecommerceSalePriceNet);
                    this.f.nameForEcommerce.setValue(x.nameForEcommerce);
                    this.f.descriptionForEcommerce.setValue(x.descriptionForEcommerce);
                    this.f.allowEcommerceSale.setValue(x.allowEcommerceSale);
                    this.f.allowMobileAppSale.setValue(x.allowMobileAppSale);
                    this.f.quantityAvailableForEcommerce.setValue(x.quantityAvailableForEcommerce);
                    this.f.availableFromDate.setValue(x.availableFromDate);
                    this.f.availableToDate.setValue(x.availableToDate);
                    this.f.slug.setValue(x.slug);
                    this.f.mobileAppSalePrice.setValue(x.mobileAppSalePrice);
                    this.f.mobileAppSalePriceNet.setValue(x.mobileAppSalePriceNet);
                    this.f.nameForMobileApp.setValue(x.nameForMobileApp);
                    this.f.descriptionForMobileApp.setValue(x.descriptionForMobileApp);
                    this.f.forOpenDay.setValue(x.forOpenDay);
                    this.f.multiSport.setValue(x.multiSport);
                    this.f.medicover.setValue(x.medicover);
                    this.f.pzuSport.setValue(x.pzuSport);
                    this.f.profit.setValue(x.profit);
                    this.f.validFromHour.setValue(x.validFromHour);
                    this.f.validToHour.setValue(x.validToHour);
                    this.f.activeInMonday.setValue(x.activeInMonday);
                    this.f.activeInTuesday.setValue(x.activeInTuesday);
                    this.f.activeInWednesday.setValue(x.activeInWednesday);
                    this.f.activeInThursday.setValue(x.activeInThursday);
                    this.f.activeInFriday.setValue(x.activeInFriday);
                    this.f.activeInSaturday.setValue(x.activeInSaturday);
                    this.f.activeInSunday.setValue(x.activeInSunday);
                    this.f.allowedVisitsForOpenDay.setValue(x.allowedVisitsForOpenDay);
                    this.f.recommended.setValue(x.recommended);
                    this.f.theLatest.setValue(x.theLatest);
                    this.f.saleCommission.setValue(x.saleCommission);

                    if (x.group) {
                        this.f.group.setValue(x.group.id);
                    }

                    for (let i = 0; i < x.services.length; i++) {
                        this.addService();
                        this.services().at(i).get('service').setValue(x.services[i].service.id);
                        this.services().at(i).get('price').setValue(x.services[i].price);
                        this.services().at(i).get('quantity').setValue(x.services[i].quantity);
                        this.services().at(i).get('commission').setValue(x.services[i].commission);
                    }

                    for (let i = 0; i < x.products.length; i++) {
                        this.addProduct();
                        this.products().at(i).get('product').setValue(x.products[i].product.id);
                    }
                });
        }
    }

    // convenience getter for easy access to form fields
    get f() { return this.form.controls; }

    onSubmit() {
        this.submitted = true;

        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        if (this.accountService.hasRole('ROLE_ADMIN') || this.accountService.hasRole('ROLE_SUPER_ADMIN')) {
            this.loading = true;

            if (this.isAddMode) {
                this.createVoucherTemplate();
            } else {
                this.updateVoucherTemplate();
            }
        } else {
            this.firstTimeConfirmationDialogRef = this._matDialog.open(FirstTimeConfirmationDialogComponent, {
                panelClass: 'first-time-confirmation-dialog',
                data: {
                    action: 'show',
                    addMode: this.isAddMode,
                    voucherTemplate: this.voucherTemplate,
                    newVoucherTemplate: this.form.value,
                },
                width: '650px',
            });

            this.firstTimeConfirmationDialogRef.disableClose = true;
            this.firstTimeConfirmationDialogRef.backdropClick().subscribe(_ => {
                // this.confirm();
            });

            this.firstTimeConfirmationDialogRef.afterClosed().subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.secondTimeConfirmationDialogRef = this._matDialog.open(SecondTimeConfirmationDialogComponent, {
                    panelClass: 'second-time-confirmation-dialog',
                    data: {
                        action: 'show',
                        addMode: this.isAddMode,
                        voucherTemplate: this.voucherTemplate,
                        newVoucherTemplate: this.form.value,
                    },
                    width: '650px',
                });

                this.secondTimeConfirmationDialogRef.disableClose = true;
                this.secondTimeConfirmationDialogRef.backdropClick().subscribe(_ => {
                    // this.confirm();
                });

                this.secondTimeConfirmationDialogRef.afterClosed().subscribe((response: FormGroup) => {
                    if (!response) {
                        return;
                    }
                    this.loading = true;

                    this.form.value.confirmingUser = response;

                    if (this.isAddMode) {
                        this.createVoucherTemplate();
                    } else {
                        this.updateVoucherTemplate();
                    }
                });
            });
        }
    }

    newService(): FormGroup {
        return this.formBuilder.group({
            service: ['', Validators.required],
            price: ['', Validators.required],
            quantity: ['', Validators.required],
            commission: [0, Validators.required],
        });
    }

    public addService() {
        this.services().push(this.newService());
    }

    public removeService(lineIdx: number) {
        this.services().removeAt(lineIdx);
    }

    public services(): FormArray {
        return this.form.get('services') as FormArray;
    }

    newProduct(): FormGroup {
        return this.formBuilder.group({
            product: [''],
        });
    }

    public addProduct() {
        this.products().push(this.newProduct());
    }

    public removeProduct(lineIdx: number) {
        this.products().removeAt(lineIdx);
    }

    public products(): FormArray {
        return this.form.get('products') as FormArray;
    }

    public allowEcommerceSale(allow: boolean): void {
        this.isEcommerceSale = allow;

        if (this.isEcommerceSale) {
            this.f.descriptionForEcommerce.setValidators(Validators.required);
            this.f.nameForEcommerce.setValidators(Validators.required);
            this.f.ecommerceSalePrice.setValidators(Validators.required);
        } else {
            this.f.descriptionForEcommerce.clearValidators();
            this.f.descriptionForEcommerce.setErrors(null);
            this.f.nameForEcommerce.clearValidators();
            this.f.nameForEcommerce.setErrors(null);
            this.f.ecommerceSalePrice.clearValidators();
            this.f.ecommerceSalePrice.setErrors(null);
        }
    }

    public useForMultiSport(multiSport: boolean): void {
        if (multiSport) {
            this.f.descriptionForEcommerce.clearValidators();
            this.f.descriptionForEcommerce.setErrors(null);
            this.f.nameForEcommerce.clearValidators();
            this.f.nameForEcommerce.setErrors(null);
            this.f.ecommerceSalePrice.clearValidators();
            this.f.ecommerceSalePrice.setErrors(null);
            this.f.nameForReceipt.clearValidators();
            this.f.nameForReceipt.setErrors(null);
            this.f.price.clearValidators();
            this.f.price.setErrors(null);
            this.f.salePrice.clearValidators();
            this.f.salePrice.setErrors(null);
            this.f.salePriceNet.clearValidators();
            this.f.salePriceNet.setErrors(null);

        } else {
            this.f.descriptionForEcommerce.setValidators(Validators.required);
            this.f.nameForEcommerce.setValidators(Validators.required);
            this.f.ecommerceSalePrice.setValidators(Validators.required);
            this.f.nameForReceipt.setValidators(Validators.required);
            this.f.price.setValidators(Validators.required);
            this.f.salePrice.setValidators(Validators.required);
            this.f.salePriceNet.setValidators(Validators.required);
        }
    }

    public allowMobileAppSale(allow: boolean): void {
        this.isMobileAppSale = allow;

        if (this.isMobileAppSale) {
            this.f.descriptionForMobileApp.setValidators(Validators.required);
            this.f.nameForMobileApp.setValidators(Validators.required);
            this.f.mobileAppSalePrice.setValidators(Validators.required);
        } else {
            this.f.descriptionForMobileApp.clearValidators();
            this.f.descriptionForMobileApp.setErrors(null);
            this.f.nameForMobileApp.clearValidators();
            this.f.nameForMobileApp.setErrors(null);
            this.f.mobileAppSalePrice.clearValidators();
            this.f.mobileAppSalePrice.setErrors(null);
        }
    }

    /**
     * on file drop handler
     */
    onFileDropped($event) {
        this.prepareFilesList($event);
    }

    /**
     * handle file from browsing
     */
    fileBrowseHandler(files) {
        this.prepareFilesList(files);
    }

    /**
     * Convert Files list to normal array list
     * @param files (Files List)
     */
    prepareFilesList(files: Array<any>) {
        for (const item of files) {
            item.progress = 0;
            this.files.push(item);
        }
        this.fileDropEl.nativeElement.value = "";
        this.uploadFilesSimulator(0);
    }

    /**
     * Simulate the upload process
     */
    uploadFilesSimulator(index: number) {
        if (index === this.files.length) {
            return;
        } else {
            const formData = new FormData();
            formData.append("image", this.files[index]);
            formData.append("gallery", this.gallery.id);
            formData.append("voucher", this.voucherTemplate.id);

            const upload$ = this.galleryService.uploadFile(formData).pipe(
                finalize(() => {this.reset(); this.deleteFile(index);})
            );

            this.uploadSub = upload$.subscribe(event => {
                if (event.type == HttpEventType.UploadProgress) {
                    this.files[index].progress = Math.round(100 * (event.loaded / event.total));
                }
            })
        }
    }

    /**
     * Delete file from files list
     * @param index (File index)
     */
    deleteFile(index: number) {
        if (this.files[index].progress < 100) {
            console.log("Upload in progress.");
            return;
        }
        this.files.splice(index, 1);
    }

    reset() {
        this.uploadSub = null;
        this.items = [];

        this.galleryService.getById(this.gallery.id).pipe(first()).subscribe((gallery: Gallery) => {
            this.gallery = gallery;

            for (let i=0; i<this.gallery.items.length; i++) {
                this.galleryService.getImageById(this.gallery.id, this.gallery.items[i].id).pipe(first())
                    .subscribe((item:string) => {
                        this.items.push(item);
                    });
            }
        });


    }

    cancelUpload() {
        this.uploadSub.unsubscribe();
        this.reset();
    }

    /**
     * format bytes
     * @param bytes (File size in bytes)
     * @param decimals (Decimals point)
     */
    formatBytes(bytes, decimals = 2) {
        if (bytes === 0) {
            return "0 Bytes";
        }
        const k = 1024;
        const dm = decimals <= 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    }

    showDeleteGalleryItemDialog(galleryItem: GalleryItem) {
        this.dialogRef = this._matDialog.open(DeleteGalleryItemDialogComponent, {
            panelClass: 'delete-gallery-item-form-dialog',
            data      : {
                action : 'show',
                galleryItem: galleryItem,
            },
            width: '650px',
        });

        this.dialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.galleryService.removeItem(galleryItem.id)
                    .pipe(first())
                    .subscribe(
                        data => {
                            this.alertService.success('Image deleted successfully', { keepAfterRouteChange: true });
                            window.location.reload();
                        },
                        error => {
                            this.alertService.error(error);
                        });

                this.dialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }

    showGalleryItemDialog(galleryItem: GalleryItem) {
        this.dialogRef = this._matDialog.open(UpdateGalleryItemDialogComponent, {
            panelClass: 'update-gallery-item-dialog',
            data      : {
                action : 'show',
                galleryItem: galleryItem,
            },
            width: '650px',
        });

        this.dialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    this.reset();
                    return;
                }

                const data = response.getRawValue();

                this.galleryService.updateItem(data['id'], data)
                    .pipe(first())
                    .subscribe(
                        data => {
                            this.alertService.success('Image updated successfully', { keepAfterRouteChange: true });
                            window.location.reload();
                        },
                        error => {
                            this.alertService.error(error);
                        });

                this.dialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }

    private createVoucherTemplate() {
        this.saving = true;
        this.voucherTemplateService.create(this.form.value)
            .pipe(first())
            .subscribe(
                (data: VoucherTemplate) => {
                    this._matSnackBar.open('Voucher template added successfully', 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-success']
                    });
                    this.router.navigate(['settings/voucher-templates/edit/' + data.id]);
                    this.saving = false;
                },
                error => {
                    this.loading = false;
                    this._matSnackBar.open('Voucher template creation error - ' + error, 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-error']
                    });
                    this.saving = false;
                });
    }

    private updateVoucherTemplate() {
        this.saving = true;
        this.form.value.posOrder = this.voucherTemplate.posOrder;
        this.voucherTemplateService.update(this.id, this.form.value)
            .pipe(first())
            .subscribe(
                (data:VoucherTemplate) => {
                    this._matSnackBar.open('Update successful', 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-success']
                    });
                    this.saving = false;
                    this.router.navigate(['settings/voucher-templates/edit/' + data.id]);
                },
                error => {
                    this._matSnackBar.open('Voucher template update error - ' + error, 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-error']
                    });
                    this.loading = false;
                    this.saving = false;
                });
    }
}
